<template lang="pug">
  .wrap
    template(v-if='!showPlaceholder')
      page-title Your Programs
        fa-icon.tooltip-icon-p(icon="info-circle" size="xs" :style="{position: 'relative', margin:'0 3px', fontSize:'0.75rem'}" v-tooltip.top="{ content:'To report on a single programme, or to compare more than one programme, search to add programmes below.', classes:'ethos-tooltip'}")

      list-header(:on-search='search')
        template(slot='action')
          el-button(type="primary" @click='toggleReorderModal') Re-order Programs
          router-link(slot='action' :to="{ name: 'itrain:programCreate' }")
            el-button(type="primary") Add New Program

      Tile(v-for="program in list.results" :program="program" @delete="onDelete" @updated='onProgramUpdated' :key="program.id")

      .pages
        el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize' :current-page.sync='currentPage')

      el-dialog(:visible="showReorderModal" title="Re-order Programs" @open='onReorderModalOpen' :before-close='toggleReorderModal')
        .reorder-modal-content( v-loading='reorderModalLoading')
          ReorderList(:list.sync='reorderProgramList')
          div.reorder-modal-footer(slot="footer")
            el-button(type="primary" @click="onSaveOrder") Save order
            el-button(type="text" @click="toggleReorderModal") Cancel

    .empty(v-else)
      empty-list

</template>

<script>
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";
import EmptyList from "../EmptyList";
import Tile from "./Tile";
import ReorderList from "./ReorderList";

export default {
  components: { PageTitle, ListHeader, EmptyList, Tile, ReorderList },
  data() {
    return {
      loading: true,
      pageSize: 20,
      currentPage: 1,
      searchParams: null,
      showReorderModal: false,
      reorderModalLoading: false,
      reorderProgramList: [],
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    showPlaceholder() {
      return !this.loading && !this.searchParams && !this.list.count;
    }
  },
  methods: {
    onProgramUpdated() {
      this.loadList();
    },
    toggleReorderModal() {
      this.showReorderModal = !this.showReorderModal;
    },
    async onDelete({ program }) {
      await this.$store.dispatch("programs/delete", {
        id: program.id
      });

      this.loadList();

      this.$message({
        type: "success",
        message: "Program deleted"
      });
    },
    async loadList({ params } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        ...params
      };
      this.loading = true;
      const data = await this.$store.dispatch("programs/fetchList", {
        params: mergedParams
      });
      this.loading = false;
      this.list = data;
      return data;
    },
    async onReorderModalOpen() {
      this.reorderModalLoading = true;
      const resp = await this.loadList({
        params: { page_size: 120 }
      });
      this.reorderProgramList = resp.results;
      this.reorderModalLoading = false;
    },
    async onSaveOrder() {
      this.reorderModalLoading = true;
      const data = this.reorderProgramList.map((program, newIndex) => ({
        id: program.id,
        order: newIndex
      }));

      await this.$store.dispatch("api/sendRequest", {
        method: "patch",
        url: `/itrain/programs/`,
        data
      });
      this.reorderModalLoading = false;
      this.toggleReorderModal();
      this.loadList();
      this.currentPage = 1;
      this.$notify({
        title: "Changes saved",
        message: "Programs order saved",
        type: "success"
      });
    },
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: { q } });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
.reorder-modal-footer {
  border-top: 1px solid #ddd;
  padding-top: 20px;
}

.reorder-modal-content {
  min-height: 150px;
}
</style>
